import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const ScoreRulesTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Question Name",
			dataIndex: "question_name",
			width: 150,
			ellipsis: true,
		},
		{
			title: "Category",
			dataIndex: "survey_category_name",
			width: 150,
			ellipsis: true,
		},
		{
			title: "Type",
			dataIndex: "type",
			width: 100,
			ellipsis: true,
			render(record) {
				return <span style={{ textTransform: "capitalize" }}>{record}</span>;
			},
		},
		{
			title: "Score",
			dataIndex: "score",
			width: 80,
			ellipsis: true,
		},
		{
			title: "Min Length",
			dataIndex: "min_length",
			width: 80,
			ellipsis: true,
		},
		{
			title: "Max Length",
			dataIndex: "max_length",
			width: 80,
			ellipsis: true,
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(record) {
				return DateTimeFormat(record);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default ScoreRulesTable;
